var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpenConfirm
    ? _c("div", { staticClass: "ConfirmLeaveView" }, [
        _c("div", { staticClass: "ConfirmLeaveView-wrapper" }, [
          _c("p", [
            _vm._v(
              "У вас есть несохраненные изменения. Вы уверены, что хотите перейти на другую страницу?"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ConfirmLeaveView-wrapperButtons" }, [
            _c("button", { on: { click: _vm.trigger } }, [_vm._v("Нет")]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.move } }, [_vm._v("Да")]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }